import './UserProfileModal.scss';
import { isIE } from 'data/function';
const optionAssociations = {
    'botmaker': 'botmaker',
    'ai': 'ia',
    'business': 'negócios',
    'helpdesk-manager': 'gestor-atendimento',
    'curious': 'curioso',
    'generalist': 'generalista',
    'other': 'outro',
};
const botmaker = 'botmaker';
const ai = 'ai';
const business = 'business';
const helpdesk = 'helpdesk-manager';
const curious = 'curious';
const generalist = 'generalist';
const other = 'other';
export class UserProfileModalController {
    static $inject = ['close', '$translate', 'AccountService2', 'SegmentService'];
    constructor(close, $translate, AccountService2, SegmentService) {
        'ngInject';
        this.close = close;
        this.$translate = $translate;
        this.AccountService2 = AccountService2;
        this.SegmentService = SegmentService;
    }
    async $onInit() {
        this.blipAccount = await this.AccountService2.me();
        this.isIE = isIE();
        this.options = [
            {
                label: await this.$translate(`user-profile-modal-select.options.${botmaker}`),
                value: botmaker,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${ai}`),
                value: ai,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${business}`),
                value: business,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${helpdesk}`),
                value: helpdesk,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${curious}`),
                value: curious,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${generalist}`),
                value: generalist,
            },
            {
                label: await this.$translate(`user-profile-modal-select.options.${other}`),
                value: other,
            },
        ];
    }
    async saveInformation() {
        try {
            const extras = {
                ...this.blipAccount.extras,
                'userProfile': optionAssociations[this.objective],
            };
            await this.AccountService2.connect();
            await this.AccountService2.setExtras(extras);
            await this.SegmentService.setAccount({
                ...this.blipAccount,
                userProfile: optionAssociations[this.objective],
            });
        }
        catch (error) {
            throw error;
        }
        finally {
            this.close();
        }
    }
}
UserProfileModalController.$inject = ['close', '$translate', 'AccountService2', 'SegmentService'];
